import { Switch } from "@mantine/core";
import { COCM_REFERRAL_TOGGLE_LABEL } from "@/components/domain/care-plan/enrollment-ui.constants";

/**
 * Props for CoCM referral toggle.
 * @agentic connections
 */
export type CoCMReferralToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

/**
 * Toggle control for enabling optional CoCM triage-based referrals.
 * @agentic connections
 */
export const CoCMReferralToggle = ({
  checked,
  onChange,
}: CoCMReferralToggleProps) => (
  <Switch
    label={COCM_REFERRAL_TOGGLE_LABEL}
    checked={checked}
    onChange={(event) => onChange(event.currentTarget.checked)}
  />
);
